// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ViewOffIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ViewOffIcon" ref={forwardedRef} {...props}>
      <path d="M4.425 13.325 3.25 14.5l1.06 1.06L15.625 4.248l-1.06-1.06-1.533 1.532C12.065 4.26 11.039 4 10 4c-3.314 0-6.5 3-8.003 6a12.9 12.9 0 0 0 2.427 3.325m1.06-1.06A11.5 11.5 0 0 1 3.708 10 11.3 11.3 0 0 1 6.26 7.044C7.49 6.054 8.794 5.5 10 5.5a5.4 5.4 0 0 1 1.886.364L10.24 7.51a2.5 2.5 0 0 0-2.727 2.727z" />
      <path d="M10 16c-1.082 0-2.15-.32-3.152-.856l1.12-1.119C8.656 14.335 9.342 14.5 10 14.5c1.206 0 2.509-.553 3.74-1.544a11.3 11.3 0 0 0 2.572-2.992 9.7 9.7 0 0 0-1.848-2.435l1.06-1.06A11.4 11.4 0 0 1 18 10c-1.5 3-4.686 6-8 6" />
      <path d="M10 12.5a2.5 2.5 0 0 1-.464-.043l2.921-2.921A2.5 2.5 0 0 1 10 12.5" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ViewOffIcon = /* @__PURE__ */ Object.assign(ViewOffIconComponent, {
  displayName: 'ViewOffIcon',
});
